import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, input, signal } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { RouteChangeService } from '@services/route-change.service';
import { ComponentCardComponent } from '@views/dashboard/token/sd-dashboard/dashboard-components/component-card/component-card.component';

@Component({
  selector: 'cmp-news-modal',
  standalone: true,
  imports: [ComponentCardComponent, ButtonComponent, NgOptimizedImage],
  templateUrl: './news-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: ``,
})
export class NewsModalComponent implements OnDestroy {
  // padding = hostBinding('style.padding', signal('20px'));

  items = signal([
    'Audited twice by leading audit companies',
    'Launch on multiple blockchains with a single supply and bridge',
    'Adjustable tokenomics after launch',
    'Multi-Asset Backing bringing a true value to your token',
    '30 days interest-free loans',
  ]);

  closeModal = input(null);

  constructor(private routeCjamgeS: RouteChangeService) {}

  ngOnDestroy(): void {
    localStorage.setItem('hasReadSdLaunch', 'true');
  }

  openDeployer() {
    this.closeModal();
    this.routeCjamgeS.openDeployer();
  }
}
